import { useEffect } from "react";

import DepollutionTable from "../../components/depollution/DepollutionTable";
import { usePageNameContext } from "../../contexts/PageTitleContext";

export default function DepollutionList() {
  const { setInfo } = usePageNameContext();
  const depollutionLabel = "Depollution";

  useEffect(() => {
    setInfo({
      name: depollutionLabel,
      desc: `Vehicles with ${depollutionLabel} still in progress`,
    });
  }, []);

  return <DepollutionTable />;
}
